function notifyLazyProduct() {
  setTimeout(async () => {
    const resL = await BSS_B2B.storage.productStorage.load();
    if (
      resL.notExistProductIds?.length ||
      resL.productIds?.length ||
      resL.variantIds?.size
    ) {
      BSS_B2B.observer.productSubject.notifyObserver(
        "LazyProduct",
        "LoadedLazyProduct",
        { ...resL }
      );
    }
  }, 1000);
}

if (typeof BSS_B2B) {
    //fix minicart
    setTimeout(() => {
        const targetMiniCart = document.querySelector("cart-drawer");
        if (targetMiniCart) {
            const mutationObserver = new MutationObserver((recordList, observe) => {
            for (const record of recordList) {
                if (
                record.type === "attributes" &&
                record.attributeName === "open" &&
                targetMiniCart.hasAttribute("open")
                ) {
                notifyLazyProduct();
                }

                if (record.target.classList.contains("cart-recommendations")) {
                notifyLazyProduct();
                }
            }
            });

            mutationObserver.observe(targetMiniCart, {
            attributes: true,
            childList: true,
            subtree: true,
            });
        }
    }, 500);
}

(function () {
  try {
    window.sessionStorage.setItem('bssB2BTaxDisplayMode', 'excl');
  } catch (e) {}
})();

(function() {
  const isPDP = window.location.pathname.includes('/products/');

  function handleSwitchElement() {
    const targetElements = document.querySelectorAll('.bss-b2b-td-switch');
    if (targetElements.length > 0) {
      targetElements.forEach(element => {
        element.style.display = isPDP ? '' : 'none';
      });
      return true; 
    }
    return false; 
  }

  if (handleSwitchElement()) return;

  const observer = new MutationObserver((mutations, obs) => {
    if (handleSwitchElement()) {
      obs.disconnect();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.addEventListener('load', handleSwitchElement);
})();


